export default __webpack_public_path__ + "static/powerful-borrowing-graphic-static-bfe5205203276f64ccbfbeaaa85b5d30.svg";